/*global jQuery, dis */

/* DIS/PLAY Script
 Author's name: Anders Gissel
 Modified by:
 Client name: Hørsholm municipality
 Date of creation: Dec. 16th, 2015
 */


(function ($, dis) {
    "use strict";


    /**
     * This module adds the "auto-truncate" function, which can cut down a list of existing entries and reveal them
     * as needed.
     *
     * @param objectConfiguration - The configuration for the object
     * @param {jQuery|HTMLElement|string|*} objectConfiguration.container - The DOM-container for this instantiation
     * @constructor
     * @extends dis.BaseModule
     */
    dis.ui.AgendaList = function (objectConfiguration) {

        // Fire the basemodule-initiator on this module.
        dis.BaseModule.call(this);

        var defaults = {
                targetSelector: "> *",
                itemsPerPage: 6
            },
            configuration = $.extend(defaults, objectConfiguration),
            dom = {},
            selfScope = this;



        /**
         * Initialization function, which is run when the module is "booting".
         */
        function init() {
            // console.log("init");
            dom.container = $(configuration.container);

            if (dom.container.length) {

                console.log(dom.container);
                $("#agendaupdate").click(function() { fetchAgendas(); });

                $.datepicker.setDefaults($.datepicker.regional["da"]);
                
                $("#agendafrom").datepicker();
                $("#agendato").datepicker();

                var filter = getParameterByName("filter");

            }

        }

        function getParameterByName(name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        }

        function fetchAgendas() {
            
            var filter = $("#agendafilter").val();
            var from = $("#agendafrom").val();
            var to = $("#agendato").val();

            console.log(filter, from, to);

                // $.ajax({
                //     url: '/',
                //     data: {"to": to, "from": from, "filter": filter},
                //     method: 'POST',
                //     success: function(data,textStatus,xhr) { 
                //         $(".agenda__list").html(data);
                //     },
                //     error: function(xhr,textStatus,errorThrown) { console.log("Error: "+errorThrown) }

                // });

            window.location = `?filter=${filter}&to=${to}&from=${from}`;
        }

        // Once everything is ready, run the init-function to get the ball rolling. The "onReady()" function lives
        // in dis.base.js.
        selfScope.onReady(init);

    };

    dis.ui.AgendaList.prototype = new dis.BaseModule();
    dis.ui.AgendaList.constructor = dis.ui.AgendaList;

}(jQuery, dis));